export default __webpack_public_path__ + "static/media/logo.cd725cc7.png";